module.exports = __webpack_public_path__ + "img/abs_2.96912cee.png";